import MediumEditor from 'medium-editor/dist/js/medium-editor'
window.MediumEditor = MediumEditor
